import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconRadiobuttonMark: AppIcon = {
  svgData: '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="4" data-fill="white"/></svg>' as RawSVG,
  name: 'radiobutton-mark',
};
